

































































































































































































import axios from 'axios';
import Comprobante from '@/models/Comprobante';
import Entidad from '@/models/Entidad.vue';
import Detalle from '@/views/autorizacionComprobantes/DetalleAutorizacion.vue';
export default {
	name: 'Granos',
	inject: ['responsive'],
	props: {
		directo: Boolean,
	},
	components: {
		Detalle,
	},
	data() {
		return {
			config: {},
			refresh: false,
			recordSelected: {},
			searchDrawer: false,
			detailsDrawer: false,
			imprimiendo: false,
			descargando: false,
			imprime: false,
			loading: true,
			start: 0,
			limit: 7,
			showBtnMore: false,
			scrollPosition: 0,
			lastScrollTop: window.pageYOffset || document.documentElement.scrollTop,
			url: './api/public/proxy/cgi/', //TODO: a definir.
			type: '',
			searchForm: {
				entidad: '',
				vendedor: '',
				zona: '',
			},
			gray: true,
		};
	},
	watch: {},
	computed: {
		descEntidadSelected() {
			return this.$store.state.perfil.descEntidadSelected;
		},
		entidadSelected(): Entidad {
			return this.$store.state.perfil.entidadSelected;
		},
		entidades() {
			return this.$store.state.config.entidades;
		},
		vendedores() {
			return this.$store.state.config.vendedores;
		},
		zonas() {
			return this.$store.state.config.zonas;
		},
		tableData(): Comprobante[] {
			return this.$store.state.autorizacion.tableData;
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		numeric: function (value) {
			return new Intl.NumberFormat('de-DE').format(value);
		},
	},
	methods: {
		doSearch(): void {
			this.resetData();
			this.callResumen();
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
		tableRowClassName({ row, rowIndex }): string {
			let bg,
				clase: string = '';
			return clase;
		},
		range(array, min, max): void {
			return array.slice(min, max);
		},
		// Muestro el drawer con los detalles del movimiento
		showDetails(record: Comprobante): void {
			this.detailsDrawer = !this.detailsDrawer;
			this.recordSelected = record;
		},
		convertDate(inputFormat: Date): string {
			function pad(s: number) {
				return s < 10 ? '0' + s : s;
			}
			const d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		},
		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.callResumen();
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.callResumen();
		},
		doImprimir(type: string): void {
			let params = {
				url: this.url,
				type: type,
				data: this.loadConfig(),
				cooperativa: this.$store.state.config.cuit,
			};
			window.open(
				`${params.url}?fechaDesde=${params.data.params.fechaDesde}&fechaHasta=${params.data.params.fechaHasta}&codcom=${params.data.params.comprobantes}&codres=${params.data.params.codres}&grano=${params.data.params.grano}&cosecha=${params.data.params.cosecha}&token=${this.$store.state.perfil.remotetoken}&files=true&type=${params.type}&cooperativa=${params.cooperativa}&entity_id=${axios.defaults.headers.common.Entity_ID}`,
				'foo',
				''
			);
		},
		downloadFiles(): void {
			let params = {
				url: this.url,
				data: this.searchForm,
			};
			this.descargando = true;
			this.$store.dispatch('downloadFiles', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar los archivos',
						position: 'top-right',
					});
				}
				this.descargando = false;
			});
		},
		downloadFile(): void {
			let params = {
				recordSelected: this.recordSelected,
			};
			this.imprimiendo = true;
			this.$store.dispatch('downloadFile', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar el archivo',
						position: 'top-right',
					});
				}
				this.imprimiendo = false;
			});
		},
		resetData(): void {
			this.$store.commit('setTableDataGranos', []);
			this.start = 0;
			this.limit = 7;
		},
		callResumen(): void {
			this.loading = true;
			this.refresh = true;
			let params = {
				start: this.start,
				limit: this.limit,
				data: this.loadConfig(),
			};
			this.$store.dispatch('callComprobantesaAutorizar', params).then(rta => {
				if (!rta.success) this.$message.error(`Error - ${rta.msg}`);
				const response = rta.items;
				if (response) {
					response.length < 7 ? (this.showBtnMore = false) : (this.showBtnMore = true);
					this.loading = false;
					this.refresh = false;
					const conta = document.querySelector('.el-main');
					if (conta) conta.scrollTop = this.scrollPosition;
				} else {
					this.loading = false;
					this.refresh = false;
				}
			});
		},
		loadConfig(): object {
			let config: object = {
				params: {
					entidad: this.searchForm.entidad,
					vendedor: this.searchForm.vendedor,
					zona: this.searchForm.zona,
				},
			};
			this.config = config;
			return config;
		},
		numberFormatter(row): string {
			return `${row.codcom2}  ${row.codtal2}  ${row.numero2}`;
		},
		reloadAutorizacion(info) {
			this.resetData();
			this.callResumen();
		},
	},
	mounted() {
		this.callResumen();
		/* TODO para cuando se implementen los filtros
		this.$store.dispatch('callAllEntidades');
		this.$store.dispatch('callAllVendedores');
		this.$store.dispatch('callAllZonas');*/
	},
	destroyed() {
		if (!this.responsive.mobile) window.removeEventListener('scroll', this.updateScroll);
	},
};
